import VersionSelector from "./VersionSelector/VersionSelector";

const Shipping = () => {
  return <VersionSelector />;
};

export default Shipping;